import React, {FunctionComponent} from "react";
import CommandDonutChart, {DonutItem} from "./CommandDonutChart";
import {
    CommandCountByEquipment,
    EquipmentCommandCategory
} from "../reactQuery/CommandCountByEquipmentReactQuery";

interface Props {
    data: CommandCountByEquipment[] | undefined;
    height?: number;
}

// Display order, label (PT) and colour for each category of the "Comandos por Equipamento" chart.
const CATEGORY_CONFIG: Array<{ category: EquipmentCommandCategory; label: string; color: string }> = [
    {category: "INVERSOR", label: "Inversor", color: "#2D5DE7"},
    {category: "RELE", label: "Relé", color: "#1BB483"},
    {category: "NCU_TRACKERS", label: "NCU/Trackers", color: "#FC531F"},
    {category: "DISJUNTOR", label: "Disjuntor", color: "#6889FC"},
    {category: "OUTROS", label: "Outros", color: "#FFB300"},
];

const CommandsByEquipmentDonutChart: FunctionComponent<Props> = ({data, height}) => {
    const countByCategory = React.useMemo(() => {
        const map = new Map<string, number>();
        (data ?? []).forEach(item => map.set(item.category, item.count));
        return map;
    }, [data]);

    const items: DonutItem[] = CATEGORY_CONFIG.map(cfg => ({
        name: cfg.label,
        value: countByCategory.get(cfg.category) ?? 0,
        color: cfg.color,
    }));

    return <CommandDonutChart items={items} height={height}/>;
};

export default CommandsByEquipmentDonutChart;
